const config = {
  publicKey: process.env.NEXT_PUBLIC_FLIP_FLAG_PUB_KEY || 'pbk_7e47ac7039f44a96'
}

export default config

